export type { TextInputProps, TextInputTrailingAction } from '../../../types/text-input';
export { TextInput } from './adapters/inbound/TextInput';
